module.exports = __webpack_public_path__ + "static/media/Stone_Tiles_004_basecolor_reduced.1701c4b7.jpg";